// extracted by mini-css-extract-plugin
module.exports = {"counterVisit":"yAHG_","outlineBtn":"rJH8V"};